import { PlannedMeasureSource } from '@/graphql';

const plannedMeasureSources: { [K in PlannedMeasureSource]: string } = {
  [PlannedMeasureSource.Immotool]: 'Immo Tool',
  [PlannedMeasureSource.Magictool]: 'Magic Tool',
};

export default plannedMeasureSources;
